import Header from "../../Header/Header";
import MenuOverflow from "./MenuOverflow";
import NavigationDemo from "../Navigation.demo";
import MenuDropdown from "./Dropdown/Menu.dropdown";

const Menu = {

    el: {},
    isMobile: false,
    dropDownOnHover: false,
    dropDownOnClick: true,

    init() {
        this.el = $('[module="structure"][method="renderMenu"]');
        if(!this.el.length) return;

        // MenuDropdown.init(this.el)
        // MenuOverflow.resize();
        NavigationDemo.init();
    },

    resize() {
        this.isMobile = window.innerWidth <= 748;

        if (this.isMobile) {

        } else {
            // const selected = this.el.find('li.selected').first()
            // Navigation.Menu.Hoverovac.select(selected);
            // MenuOverflow.resize();
        }
    },

    setSelected(url, page) {

        const mainPage = Navigation.Menu.el.find('a[href*="' + page + '"]').first().closest('li');

        Navigation.Menu.el.find('.selected').removeClass('selected');
        Navigation.Menu.el.find('a[href="' + url + '"]').parentsUntil("nav.main", '.item').addClass('selected');
        mainPage.addClass('selected');

        /// Harmonika robalovacka smerom dole
        var expanded = Navigation.Menu.el.find('.expanded');
        var actual = Navigation.Menu.el.find('a[href="' + page + '"]').closest('li');

        if (!actual.is('.expanded')) {
            this.dropDownOnClick && Navigation.Accordion.collapse(expanded);
            this.dropDownOnClick && Navigation.Accordion.expand(actual);
        }

        if (mainPage.is('.hasChildren')) {
            this.dropDownOnClick && Navigation.Accordion.expand(mainPage);
        }

        // this.Menu.Hoverovac.select(mainPage);
    },

    Item: {
        init: function () {
            Navigation.el.find('a')
                .click(function (event) {
                    Header.close();
                })

            Navigation.el.find('.item')
                .mouseover(function (event) {
                    //Navigation.Menu.Hoverovac.hover($(this));
                    !Navigation.isMobile && Navigation.dropDownOnHover && Navigation.Accordion.expand($(this));
                })
                .mouseleave(function (event) {
                    //Navigation.Menu.Hoverovac.out($(this));
                    !Navigation.isMobile && Navigation.dropDownOnHover && Navigation.Accordion.collapse($(this));
                });

        }
    },

    Plus: {
        el: {},

        init: function () {

            this.el = Navigation.el.find('nav .m-icon');
            this.bind();
        },

        bind: function () {

            this.el.unbind('click')
                .click(function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    var item = $(this).closest('li');
                    var dropdown = item.find('.dropdown')

                    if (!item.is('.expanded')) {
                        Navigation.el.find('.item.expanded .dropdown').slideUp(300);
                        Navigation.el.find('.item.expanded').removeClass('expanded');
                        dropdown.slideDown({
                            start: function () {
                                $(this).css({display: "flex"})
                            }, duration: 300
                        });

                        item.addClass('expanded');
                    } else {
                        dropdown.slideUp(300);
                        item.removeClass('expanded');

                    }

                    // var item = $(this).closest('li');
                    // item.trigger('click');

                });
        }
    },

    Accordion: {

        time: 300,

        init: function (time) {

            this.time = time;
            Navigation.el.find('.dropdown a').click(function (event) {
                event.stopPropagation();
            });
        },

        expand: function (item) {

            if (!item.is('.hasChildren') || !item.length) return;
            item.find('.dropdown').slideDown({
                start: function () {
                    $(this).css({display: "flex"})
                }, duration: this.time
            });
            item.addClass('expanded');

        },

        collapse: function (item) {
            if (!item.is('.hasChildren') || !item.length) return;
            item.find('.dropdown').stop().slideUp(this.time);
            item.removeClass('expanded');
        }

    },
}

export default Menu;